<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>smartphone</mat-icon></div>
      <h4>{{ formMode }} Token</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Token</mat-label>
        <input matInput formControlName="Token" [readonly]="editToken" />
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Creation Date</mat-label>
        <input matInput formControlName="CreationDate" [readonly]="editToken" />
      </mat-form-field>

      <div class="toggle-row">
        <span class="toggle-label">Enabled</span>
        <mat-slide-toggle formControlName="Enabled" [disabled]="editToken" color="primary"></mat-slide-toggle>
      </div>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (editToken) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
